'use strict';

import { logger } from '@/logging';


export const fetchOwnComments = async ({ dispatch }, userID) => {
	return await dispatch('find', { query: { author: userID }});
};

//=================================================================================================================

export const fetchByActionID = async ({ dispatch }, actionID) => {
	return await dispatch('find', { query: { action: actionID }});
};


//=============================================================================
//=========================== Comment Edit Dialog =============================
//=============================================================================


export const editComment = ({ commit }, { item }) => {
	commit('setEditCopy', item.clone());
};

//=================================================================================================================

export const cancelCommentChanges = ({ commit }, { item }) => {
	commit('clearEditCopy');
	item.id && item.reset();
};


//=================================================================================================================

export const saveComment = async ({ commit }, { item }) => {
	try {
		await item.save();
		commit('clearEditCopy');
	}
	catch(err) {
		logger.get('comments').error('Error when saving comment', err);
		throw err;
	}
};
//=================================================================================================================

export const deleteComment = async (context, { item }) => {
	try {
		return await item.remove();
	}
	catch(err) {
		logger.get('comments').error('Error when deleting comment', err);
		throw err;
	}
};
